import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/sections/Header";
import Hero from "@/sections/Hero";
import Services from "@/sections/Services";
import HowItWorks from "@/sections/HowItWorks";
import ServiceArea from "@/sections/ServiceArea";
import QuoteSection from "@/sections/QuoteSection";
import Footer from "@/sections/Footer";
import AuthCallback from "@/sections/AuthCallback";
import Admin from "@/sections/Admin";

const Landing = () => (
  <div className="min-h-screen bg-slate-50">
    <Header />
    <main>
      <Hero />
      <Services />
      <HowItWorks />
      <ServiceArea />
      <QuoteSection />
    </main>
    <Footer />
  </div>
);

function AppRouter() {
  const location = useLocation();
  // Il session_id arriva nel fragment: gestiscilo PRIMA di qualsiasi rotta
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
